<template>
  <div class="LeftConentBottom" v-if="dataInfo">
    <div class="LeftConentBottom_module">
      <div class="LeftConentBottom_module_tit">
        {{ $t("DataInfo.Introduction") }}
      </div>
      <div class="LeftConentBottom_module_info">
        {{ dataInfo.introduction }}
      </div>
    </div>
    <!-- <div class="LeftConentBottom_module">
      <div class="LeftConentBottom_module_tit">{{$t('DataInfo.Address')}}</div>
      <div class="LeftConentBottom_module_info">
        {{dataInfo.releaseMech}}
        <div v-if="dataInfo.creator">/ {{dataInfo.creator}}</div>
      </div>
    </div> -->
    <!-- -----------------标识信息--------------------- -->
    <div class="LeftConentBottom_module_bottom">
      <div class="LeftConentBottom_module_tit">
        {{ $t("DataInfo2.IdentityInformation") }}
      </div>
      <!-- <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Id") }}:</div>
          {{ dataInfo.dataId }}
        </div>
      </div> -->
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Key") }}:</div>
          {{ dataInfo.keywords }}
        </div>
      </div>

      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.provider") }}:</div>
          {{ dataInfo.createInsti }}
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.DataType") }}:</div>
          {{ dataInfo.name }}
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Source") }}:</div>
          {{ $t("DataInfo.Public") }}
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.DataSetFormat") }}:</div>
          {{ dataInfo.dataFormat }}
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.ReleaseDate") }}:</div>
          {{ dataInfo.createTime }}
        </div>
      </div>

      <!-- ------------------------------------------------- -->
      <div class="LeftConentBottom_module_tit" style="margin-top: 20px">
        {{ $t("DataInfo2.DataSetDescriptionInformation") }}
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.DataSetName") }}:</div>
          {{ dataInfo.productName }}
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.GeographicPosition") }}:</div>
          {{ dataInfo.territorialScope }}
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.SpatialReference") }}:</div>
          <!-- {{       dataInfo.temporalRes }} -->
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Spatial") }}:</div>
          {{ dataInfo.temporalRes }}
        </div>
      </div>
      <!-- ------------------------------分发与访问信息 -->
      <div class="LeftConentBottom_module_tit" style="margin-top: 20px">
        {{ $t("DataInfo2.DistributeandAccessInformation") }}
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.ContactName") }}:</div>
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Phone") }}:</div>
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Email") }}:</div>
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Address") }}:</div>
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.PostCode") }}:</div>
        </div>
      </div>
      <div class="LeftConentBottom_module_bottom_content">
        <div>
          <div class="name">{{ $t("DataInfo2.Permission") }}:</div>
        </div>
      </div>
    </div>
    <!-- **************************** -->
    <div class="LeftConentBottom_module_bottom">
      <div class="LeftConentBottom_module_bottom_content width_100">
        <div>{{ $t("DataInfo.Copyright") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .LeftConentBottom {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    background: #fff;
    .LeftConentBottom_module {
      margin-top: 20px;
      margin-bottom: 10px;
      .LeftConentBottom_module_tit {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(65, 101, 235, 1);
      }
      .LeftConentBottom_module_info {
        word-wrap: break-word;
        font-size: 14px;
        color: #000;
        font-weight: 600;
      }
      .LeftConentBottom_module_ul {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        color: #000;
      }
    }
    .LeftConentBottom_module_bottom {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .LeftConentBottom_module_tit {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(65, 101, 235, 1);
      }
      .LeftConentBottom_module_tit {
        width: 100%;
      }
      .LeftConentBottom_module_bottom_content {
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-bottom: 1px solid #d8d8d8;
        padding: 12px 0;
        .name {
          margin-right: 10px;
          white-space: nowrap;
        }

        > div {
          padding-right: 20px;
          width: 50%;
          display: flex;
          flex-direction: row;
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #000;
        }
      }
      .width_100 {
        width: 100%;
        font-size: 16px;

        padding-bottom: 30px;
        border-bottom: none;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .LeftConentBottom {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    background: #fff;
    .LeftConentBottom_module {
      margin-top: 20px;
      margin-bottom: 10px;
      .LeftConentBottom_module_tit {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #000;
      }
      .LeftConentBottom_module_info {
        word-wrap: break-word;
        font-size: 16px;
        color: #000;
      }
      .LeftConentBottom_module_ul {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        color: #000;
      }
    }
    .LeftConentBottom_module_bottom {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      .LeftConentBottom_module_tit {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #000;
      }
      .LeftConentBottom_module_bottom_content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-bottom: 1px solid #d8d8d8;
        padding: 12px 0;

        > div {
          width: 50%;
          display: flex;
          flex-direction: row;
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #000;
        }
      }
      .LeftConentBottom_module_bottom_content:last-child {
        border-bottom: none;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .LeftConentBottom {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    background: #fff;
    .LeftConentBottom_module {
      margin-top: 20px;
      margin-bottom: 10px;
      .LeftConentBottom_module_tit {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #000;
      }
      .LeftConentBottom_module_info {
        word-wrap: break-word;
        font-size: 16px;
        color: #000;
      }
      .LeftConentBottom_module_ul {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        color: #000;
      }
    }
    .LeftConentBottom_module_bottom {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      .LeftConentBottom_module_tit {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #000;
      }
      .LeftConentBottom_module_bottom_content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-bottom: 1px solid #d8d8d8;
        padding: 12px 0;

        > div {
          width: 50%;
          display: flex;
          flex-direction: row;
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #000;
        }
      }
      .LeftConentBottom_module_bottom_content:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>